import ActionFactory from "./action-factory";
import LoadState from "./load-state";
import Prune from "./prune";
import LoadTimeline from "./load-timeline";
import LoadEvents from "./load-events";
import NoOperation from "./no-operation";

ActionFactory.register('LoadState', LoadState);
ActionFactory.register('Prune', Prune);
ActionFactory.register('LoadTimeline', LoadTimeline);
ActionFactory.register('LoadEvents', LoadEvents);
ActionFactory.register('NoOperation', NoOperation);
